import type { UserUpdateT } from './types';

export const getTrackingFields = (data: UserUpdateT): Array<string> => {
  /* This code exists because the fields in the API mean different things based on what you are changing.
        - if you're updating the email, the `password` field is the current password.
        - if you're updating the password,current_password field is the current password.
      This function checks what you're updating, and based on that sends the correct strings to the tracking-api.
      When the old Account Settings page is gone, we should remove this special case.
      https://trello.com/c/molG04x9/1359-remove-special-currentpassword-case-in-user-api
   */
  const fields = Object.keys(data);
  let filterFn: (f: string) => boolean = () => true;
  if (fields.includes('currentPassword')) {
    // updating password
    filterFn = (f) => f !== 'currentPassword';
  }
  if (fields.includes('email')) {
    // updating email
    filterFn = (f) => f !== 'password';
  }
  return fields.filter(filterFn);
};
